import {Component, Input, Inject, OnInit} from 'ng-metadata/core';
//import { UserSessionManagerService } from '../security/userSessionManager.service';
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';
import {SmoothScrollUtil} from '../../../nddUtils/smoothScrollUtil.service';
import {
    getNewspapersSearchEnabled,
    getBackendSystem,
    isShowReasearcherAssistantByIcon
} from '../../../appConfig/appConfigForward';
const cloneDeep = require('lodash/cloneDeep');
const find = require('lodash/find');
const filter = require('lodash/filter');
const orderBy = require('lodash/orderBy');
const isEqual = require('lodash/isEqual');

import {getAttributesMap, getVid} from '../../../appConfig/appConfigForward';
import {MobileMenu} from '../menu.service';
import {PrimoExploreService} from '../../../primoExplore/primoExplore.service';
import {UserSessionManagerService} from  '../../../security/userSessionManager.service';
import {JwtUtilService} from  '../../../security/jwtUtil.service';
import {TabsAndScopesSelectorService} from '../../searchBar/tabsAndScopesSelector/tabsAndScopesSelector.service';
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {PrimolyticsService, beacon} from '../../../analytics/primolytics.service';
import {SearchFieldsService} from "../../search.fields.service";
import {SearchStateService} from "../../searchState.service";
import {SearchService} from "../../search.service";
import {BrowseSearchBarService} from "../../browse/browseSearchBar/browseSearchBar.service";
import {DatabasesService} from "../../../journals/databases.service";
import {TemplateUtil} from '../../../nddUtils/templateUtil.service';
import {MappingTablesCache} from '../../../mappingTablesCache/mappingTablesCache.service';
import { CMIntegrationService } from '../../../cm_integration.service';
import {preventStateReload} from "../../../infra/annotations";
import {MediaQueries} from "../../../infra/mediaQueries.service";
import { ActionListService } from '../../actions/actionList.service';
import {ReportProblemService} from "../../../reportProblem/reportProblem.service";
import { FavoritesWarningMessageService } from '../../../favorites/favoritesWarningMessage/favoritesWarningMessage.service';
import {AnalyticsUtils} from "../../../nddUtils/analyticsUtils.service";
import { AuthoritySearchBarService } from '../../authority/authoritySearchBar/authoritySearchBar.service';
import {ResearchAssistantService} from "../../../researchAssistant/researchAssistant.service";

const get= require('lodash/get');

@Component({
    selector: 'prm-main-menu',
    // templateUrl: 'components/search/topbar/mainMenu/main-menu.html'
    template: '<div class="layout-full-height" ng-include="::$ctrl.templateUrl"></div>'
})

export class PrmMainMenu {
    @Input() menuType;
    private mainView;
    private mainMenuConfiguration;
    private vid = getVid();
    private languages: string[];
    private tLanguages: string[];
    private templateUrl: string;
    private NEWSPAPERS_SEARCH_ENABLED: boolean = getNewspapersSearchEnabled();
    private displayLanguage: boolean = true;
    private showUserArea: boolean = true;
    private FAVORITES_STATE = STATE_NAMES.FAVORITES;

    private KEY_CODE = {
        COMMA: 188,
        SEMICOLON: 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW: 37,
        UP_ARROW: 38,
        RIGHT_ARROW: 39,
        DOWN_ARROW: 40,
        TAB: 9,
        BACKSPACE: 8,
        DELETE: 46
    };


    public isShowTags(config){
        return (config !== 'tags' || (!this.configurationUtil.getDiscoveryLocalNoLogin() && !this.configurationUtil.getDiscoveryServicesPage() && !this.configurationUtil.getDiscoveryWithExternalNoLogin()))
    }
    
    
    public isDiscoveryLocalNoLogin(){
        return this.configurationUtil.getDiscoveryLocalNoLogin() ;
        
    }
    
    public isDiscoveryServicesPage(){
        return this.configurationUtil.getDiscoveryServicesPage();
    }

    public isDiscoveryWithExternalNoLogin() {
        return this.configurationUtil.getDiscoveryWithExternalNoLogin();
    }

    private menuLabels = {
        atoz: 'nui.mainmenu.label.journalsearch',
        citationlinker: 'nui.mainmenu.label.citationlinker',
        tags: 'nui.mainmenu.label.tags',
        dbsearch: 'nui.mainmenu.label.databasesearch',
        browse: 'nui.mainmenu.label.browse',
        newspapers_search: 'nui.mainmenu.label.newspapers_search',
        authority : 'nui.mainmenu.label.authoritySearch',
        researchAssistant: 'mainmenu.label.researchAssistant'
    }

    private menuTooltips = {
        atoz: 'nui.mainmenu.description.journalsearch',
        citationlinker: 'nui.mainmenu.description.citation_linker',
        tags: 'nui.mainmenu.description.tags',
        dbsearch: 'nui.mainmenu.description.databasesearch',
        browse: 'nui.mainmenu.description.browse',
        newspapers_search: 'nui.mainmenu.label.newspapers_search.tooltip',
        authority : 'nui.mainmenu.description.authority',
        researchAssistant : 'nui.mainmenu.description.researchAssistant'
    }

    private openInCurrent = ['tags','citationlinker','dbsearch','newspapers_search', 'browse','library_search', 'authority'];

    private RESEARCH_ASSISTANT_STATE = STATE_NAMES.RESEARCH_ASSISTANT;

    constructor(private configurationUtil: ConfigurationUtil,
                private mappingTablesCache: MappingTablesCache,
                private mobileMenu: MobileMenu,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$mdMedia') private $mdMedia: ng.material.IMedia,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$mdDialog') private $mdDialog,
                @Inject('$interpolate') private $interpolate,
                @Inject('searchBoxIcons') private searchBoxIcons: Object[],
                private primoExploreService: PrimoExploreService,
                private smoothScrollUtil: SmoothScrollUtil,
                private reportProblemService: ReportProblemService,
                private favoritesWarningMessageService: FavoritesWarningMessageService,
                private  userSessionManagerService: UserSessionManagerService,
                private  jwtUtilService: JwtUtilService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private primolyticsService: PrimolyticsService,
                @Inject('$timeout') private $timeout,
                private  searchFieldsService: SearchFieldsService,
                private  searchStateService: SearchStateService,
                private searchService: SearchService,
                private databasesService: DatabasesService,
                private browseSearchBarService: BrowseSearchBarService,
                private templateUtil: TemplateUtil,
                private cmIntegrationService: CMIntegrationService,
                private mediaQueries: MediaQueries,
                private actionListService: ActionListService,
                private analyticsUtils: AnalyticsUtils,
                private authoritySearchBarService: AuthoritySearchBarService,
                private researchAssistantService: ResearchAssistantService) {
        //console.log('param: ' + this.theMenuType );
        this.mainMenuConfiguration = cloneDeep(configurationUtil.getMainMenuConfiguration());
        if (this.mainMenuConfiguration) {

            let help = find(this.mainMenuConfiguration.mainview, (e) => e.label === 'primo_help');
            if (help) {
                help.url = $state.href('static',
                    {
                        section: 'help',
                        vid: this.vid,
                        lang: this.$translate.use()
                    });
            }
            this.mainView = this.mainMenuConfiguration.mainview;
            if (!this.NEWSPAPERS_SEARCH_ENABLED) {
                this.mainView = this.mainView.filter((main) => this.configurationUtil.isSuprima()? main.label !=  'NewspaperSearch' :  main.label !== 'newspapers_search');
            }
            if(this.hideRapidoBlankFormLinkBasedOnUserGroup()){
                this.mainView = this.mainView.filter((main) => main.url !== 'BlankIll');
            }
        }

        if (this.configurationUtil.isSuprima()) {
            this.menuLabels['citationlinker'] = undefined;
            this.menuTooltips['citationlinker'] = undefined;
            this.menuLabels['tags'] = undefined;
            this.menuTooltips['tags'] = undefined;
        }
        this.languages = getAttributesMap().interfaceLanguageOptions.split(',');
        this.tLanguages = getAttributesMap().threeLettersLanguagesOptions.split(',');


		if (!this.cmIntegrationService.isEnabled()) {
	        for(let urlConfig of this.mainView){
	            this.updateUrl(urlConfig)
	        }
		} else {
			setTimeout(() => {
				for(let urlConfig of this.mainView){
	            	this.updateUrl(urlConfig)
	        	}
				this.cmIntegrationService.registerNavMenu(this.mainView, this.getMenuLabel.bind(this), this.performAction.bind(this))},2000);
        }

        this.displayLanguage = this.languages && this.languages.length > 1;
        if (this.$state.current.name === 'deposit' || this.$state.current.name === 'delivery' || this.$state.current.name === 'canonDelivery' || this.$state.current.name === 'cnameDelivery') {
            this.showUserArea = false;
        }
    }

    ngOnInit() {
        if (this.menuType === 'menu') {
            this.templateUrl = 'components/search/topbar/mainMenu/main-menu.html';
        }
        else {
            this.templateUrl = 'components/search/topbar/mainMenu/main-menu-full.html';
        }
    }

    ngAfterViewInit() {
        this.$timeout(()=> {
            this.smoothScrollUtil.scrollTo('mainMenuFullCloseButton', '', '');
        }, 300);

    }

    public getMenuLabel(urlConfig) {
        return this.menuLabels[urlConfig.label] ? this.menuLabels[urlConfig.label] : 'mainmenu.label.' + urlConfig.label;
    }

    public getMenuTooltip(urlConfig) {
        return this.menuTooltips[urlConfig.label] ? this.menuTooltips[urlConfig.label] : 'nui.mainmenu.description.' + urlConfig.label;
    }

    private closeLinksMenu() {
        this.mobileMenu.setLinksMenuVisible(false);
        this.$mdDialog.cancel();
        this.removeBackgroundDarkClass();
    }

    private closeLinksMenuAfterNavigation() {
        this.mobileMenu.setLinksMenuVisible(false);
        this.$mdDialog.hide();
        this.removeBackgroundDarkClass();
    }

    private keyDownSupport(e ,link) {
        if(link == this.viewUrlsList[this.viewUrlsList.length - 1] && e.keyCode === this.KEY_CODE.TAB && !e.shiftKey){
            let elem = document.querySelector('.overlay-menu-content');
            if (elem) {
                elem.tabIndex = 0;
                elem.focus();
            }
        }
    }

    private disableMobileMenu() {
        this.favoritesWarningMessageService.hideFavoritesWarningForGuestsByMenu();
        this.mobileMenu.setMobileMenu(false);
        this.mobileMenu.setLinksMenuVisible(true);
        this.showMainMenu();
    }

    public showMainMenu() {
        let mainMenuTemplate = '' +
            '<md-dialog aria-label="Main menu" ' +
            'class="light-on-dark-dialog full-cover-dialog"> ' +
            '<md-dialog-content class="layout-full-height"> ' +
            '<prm-main-menu menu-type="full"></prm-main-menu> ' +
            '</md-dialog-content>' +
            '</md-dialog>';

        this.addBackgroundDarkClass();

        this.$mdDialog.show({
            bindToController: true,
            controller: function () {
            },
            controllerAs: 'ctrl',
            template: mainMenuTemplate,
        }).then(()=>{ //callback to run when dialog closed

        }, ()=>{
            document.querySelector('#more-links-button').focus();
        });
    }

    public addBackgroundDarkClass() {
        this.primoExploreService.dimScreen(true);
    }

    public removeBackgroundDarkClass() {
        this.primoExploreService.dimScreen(false);
    }

    private getTemplateUrl(_menuType) {
        if (_menuType === 'menu') {
            return 'components/search/topbar/mainMenu/main-menu.html';
        }
        else {
            return 'components/search/topbar/mainMenu/main-menu-full.html';
        }
    }

    private get viewId() {
        return this.mainMenuConfiguration.id;
    }

    private get isDepositDisplay() {
        return this.mobileMenu.getDepositDisplay();
    }

    private get viewUrlsList() {
        return this.mainView;
    }

    private get viewUrlsCount() {
        return this.mainView.length;
    }

    private showCount() {
        if (this.$mdMedia('lg')) {
            return 6;
        }
        if (this.$mdMedia('md')) {
            return 4;
        }
        if (this.$mdMedia('sm')) {
            return 2;
        }
        if (this.$mdMedia('xs')) {
            return 0;
        }
        return 6;
    }

    private showMoreOptionsButton() {
        let s = this.showCount();
        if (s === 0) {
            return false;
        }
        return this.mainView.length > s;
    }

    /*
     *  _target:   _self  ==> Open in current window
     *             _blank ==> Open in new window
     */
    public updateUrl(urlConfig) {

        let mtLine = this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.MAIN_MENU_URLS_FOR_THE_NEW_UI, {source1: urlConfig.label, source2: this.vid, target: this.$translate.use() });
        let url = (mtLine && mtLine.length > 0 && mtLine[0]['source3']) ? mtLine[0]['source3'] : urlConfig.url;

        url = this.templateUtil.resolveUrlTemplate(url);

        if (this.handleJournals(urlConfig) || this.isUrlHardCodedTreatment(urlConfig)) {
            return;
        }
        if (url.startsWith('/discovery/browse')) {
            urlConfig['action'] = ()=>{this.browseUseReport();};
            this.addSrefParams(urlConfig, STATE_NAMES.BROWSE_SEARCH, {vid: this.vid});
            return;
        }

        urlConfig['href'] = url;
    }

    private setStyle(urlConfig){
        urlConfig.style = true;
    }

    private handleJournals(urlConfig) {
        if (urlConfig.label != 'atoz')
            return false;
        if (urlConfig.url.startsWith('dlSearch.do')) {
            this.addSrefParams(urlConfig, STATE_NAMES.JOURNAL_SEARCH, {vid: this.vid, lang: this.$translate.use()});
            urlConfig['action'] = () => {
                this.runJournalsBeacon();
            };


        }
        else {
            let url = this.setLanguage(urlConfig.url)
            this.goToExternalJournal(url, urlConfig);
            urlConfig['action'] = () => {
                this.runJournalsBeacon();
            };
        }
        return true;
    }

    private goToExternalJournal(url, urlConfig) {
        urlConfig['href'] = url;
    }

    private getUrl() {
        return this.$location.protocol() + '://' + this.$location.host() + ':' + this.$location.port() + '/primo_library/libweb/action/searchDB.do?fn=nuiSearchDbIframe&vid=' + this.vid;
    }

    @beacon({'p': 'click', 'op': 'browsePage'})
    private browseUseReport(): void {
        this.browseSearchBarService.searchBarInput = ''
        if (this.browseSearchBarService.selectedScope != undefined) {
            this.browseSearchBarService.selectedScope = this.browseSearchBarService.scopes[0]
        }
        this.closeLinksMenu();
    }

    private authorityUseReport(): void {
        this.authoritySearchBarService.searchBarInput = '';
        this.closeLinksMenu();
    }

    @beacon({ 'p': 'general', 'op': 'gotoCollectionDiscovery' })
    private runCollectionDiscoveryBeacon(): void {}

    @beacon({ 'p': 'general', 'op': 'goToNewspapersfromMainMenu' })
    private runNewspaperSearchBeacon(): void {}

    @beacon({'p': 'general', 'op': 'gotoAZ'})
    private runJournalsBeacon(): void {}

    private isUrlHardCodedTreatment(urlConfig) {
        let url = urlConfig.url;
        if (urlConfig.label === 'citationlinker') {
            urlConfig['action'] = ()=>{this.closeLinksMenu();};
            this.addSrefParams(urlConfig, STATE_NAMES.CITATION_LINKER, {vid: this.vid, lang: this.$translate.use()});
        }
        else if (urlConfig.label === 'tags') {
            urlConfig['action'] = ()=>{this.closeLinksMenu();};
            this.addSrefParams(urlConfig, STATE_NAMES.TAGS, {vid: this.vid, lang: this.$translate.use()});
        }
        else if (urlConfig.label === 'dbsearch' || urlConfig.label === 'DatabaseSearch') {
            urlConfig['action'] = ()=>{this.closeLinksMenu();};
            this.addSrefParams(urlConfig, STATE_NAMES.DB_SEARCH, {vid: this.vid, lang: this.$translate.use()});
        }
        else if (this.configurationUtil.isSuprima()? urlConfig.label ===  'NewspaperSearch' :  urlConfig.label === 'newspapers_search') {
            urlConfig['action'] = ()=>{
                this.runNewspaperSearchBeacon();
                this.closeLinksMenu();
                this.searchFieldsService.mainSearch = '';
                this.searchService.resetResultObject();
            };
            this.addSrefParams(urlConfig, STATE_NAMES.NEWSPAPERS, {vid: this.vid, lang: this.$translate.use()});
        }
        else if (urlConfig.label === 'browse' || urlConfig.label === 'BrowseSearch') {
            urlConfig['action'] = ()=>{this.browseUseReport();};
            this.addSrefParams(urlConfig, STATE_NAMES.BROWSE_SEARCH, {vid: this.vid, lang: this.$translate.use()});
        }
        else if ( (urlConfig.label === 'collection_discovery' || urlConfig.label === 'CollectionDiscovery') && !(url.startsWith('/action/collectionDiscovery.do')) ) {
            urlConfig['action'] = () => { this.runCollectionDiscoveryBeacon(); };
            this.addSrefParams(urlConfig, STATE_NAMES.COLLECTION_DISCOVERY, { vid: this.vid, lang: this.$translate.use() });
        }
        else if (url.startsWith('/action/collectionDiscovery.do')) {
            urlConfig['href'] = this.$location.protocol() + '://' + this.$location.host() + ':' + this.$location.port() + '/primo_library/libweb' + url;
        }
        else if (url.startsWith('dlSearch.do')) {
            urlConfig['href'] = this.$location.protocol() + '://' + this.$location.host() + ':' + this.$location.port() + '/primo_library/libweb/action/' + url;
        }

        else if (url === '/action/search.do') {
            this.addSrefParams(urlConfig, STATE_NAMES.SEARCH, {vid: this.vid, lang: this.$translate.use()});
        }
        else if (url.endsWith('lang=')) {
            let updatedUrl = this.setLanguage(url);
            urlConfig['href'] = updatedUrl;

        }
        else if (url === 'BlankIll') {
            this.addSrefParams(urlConfig, STATE_NAMES.BLANK_ILL, {vid: this.vid});
        }
        else if (url === 'PurchaseRequest') {
            this.addSrefParams(urlConfig, STATE_NAMES.PURCHASE_REQUEST, {vid: this.vid});
        }
        else if (url === 'jsearch') {
            urlConfig['action'] = ()=>{
                this.resetSearchParams();
                this.closeLinksMenu();
            };
            this.addSrefParams(urlConfig, STATE_NAMES.JOURNAL_SEARCH, {vid: this.vid, lang: this.$translate.use()});
        }
        else if (url === 'authsearch') {
            urlConfig['action'] = ()=>{this.authorityUseReport();};
            this.addSrefParams(urlConfig, STATE_NAMES.AUTHORITY_SEARCH, {vid: this.vid});
        }
        else if (url === 'researchAssistant') {
            urlConfig['action'] = ()=>{
                this.closeLinksMenu();
            };
            this.setStyle(urlConfig);
            this.addSrefParams(urlConfig, STATE_NAMES.RESEARCH_ASSISTANT, {vid: this.vid});
        }
        else if (url.indexOf('/discovery/search?') > -1 && url.indexOf('vid=' + this.vid) > -1) {
            this.addSrefParams(urlConfig, STATE_NAMES.SEARCH, {vid: this.vid, lang: this.$translate.use()});
        }
        else if (urlConfig.label === 'orgList') {
            urlConfig['action'] = ()=>{this.closeLinksMenu();};
            this.addSrefParams(urlConfig, STATE_NAMES.ORGANIZATION_LIST, {vid: this.vid});
        }
        else {
            return false;
        }
        return true;

    }

    private setLanguage(url) {
        let index = 0;
        let currentLang = this.$translate.use();
        for (; index < this.languages.length; ++index) {
            if (this.languages[index] === currentLang) {
                break;
            }
        }

        if (this.tLanguages.length > index) {
            return url + this.tLanguages[index];
        } else {
            return url;
        }
    }

    private resetSearchParams() {
        this.searchFieldsService.reset();
        this.searchStateService.resetSearchObject();
        this.searchService.restSignInAlertMessage();
    }

    private userName() {
        if (getBackendSystem() === 'suprima') {
            return this.userSessionManagerService.getUserNameForDisplay();
        } else {
            return this.userSessionManagerService.getUserName();
        }
    }

    get isLoggedIn() {
        return this.userName().length > 0;
    }

    private dispalyResourceSharing(url) {
        if (this.userSessionManagerService.isGuest() && url.includes('pds_handle={{pds_handle}}')) {
            return true;
        }
        return false;
    }


    private hideLegantoMenuLink(url, label) {
        //returns true if the user is a guest
        //and the main menu link label is leganto
        if (this.userSessionManagerService.isGuest() && label === 'leganto') {
            return true;
        }
        return false;
    }

    // Indicate whether a button opens in a new window or not
    private newWindowIndication(urlConfig) {
        if (!this.$translate.isReady()){
            return undefined;
        }
        if (urlConfig.label == 'atoz' && !urlConfig.url.startsWith('dlSearch.do')){ // for sfx
            return this.$translate.instant('nui.aria.newWindow');
        }
        if (urlConfig.target === "_blank" && this.openInCurrent.indexOf(urlConfig.label) === -1) {
            return this.$translate.instant('nui.aria.newWindow');
        } else {
            return "";
        }
    }

    private isSignedIn() {
        return this.jwtUtilService.isSignedIn();
    }

    public performAction(urlConfig) {
        let index = this.mainView.findIndex( mainMenuLabel => mainMenuLabel.label === urlConfig['label'] );
        if(get(urlConfig,'url','') === 'researchAssistant') {
            this.researchAssistantService.cameFrom = 'RESEARCH_ASSISTANT_MENU';
        }
        this.runMainMenuLinkBeacon(index + 1);
        this.sendAnalytics(this.analyticsUtils.eventsNames.NAVIGATE_MAIN_MENU, urlConfig);
        if(isEqual(urlConfig.url, 'BlankIll') || isEqual(urlConfig.url, 'PurchaseRequest')) {
            this.sendAnalytics(this.analyticsUtils.eventsNames.CREATE_PHYSICAL_REQUEST, urlConfig);
        }

        if (urlConfig['action']) {
            urlConfig['action']();
        }
        return true;
    }

    @beacon({'p': 'general', 'op': 'mainMenuLink'})
    public runMainMenuLinkBeacon(index) {
        this.searchService.cameFromState = String(index);
    }

    private sendAnalytics(event, urlConfig) {
        let payload = this.getAnalyticsPayload(event, urlConfig);
        this.analyticsUtils.trackUsage(event, payload);
    }

    private getAnalyticsPayload(event, urlConfig) {
        switch(event){
            case this.analyticsUtils.eventsNames.NAVIGATE_MAIN_MENU:
                return {
                'Link Name': urlConfig.label
            }
            case this.analyticsUtils.eventsNames.CREATE_PHYSICAL_REQUEST:
                return  {
                    "Request Type": this.getAnalyticsRequestType(urlConfig.url),
                    "Request Action Type": "Open",
                    "Level Type": 'Blank Form'
                }
        }
    }

    private getTargetAttribute(urlConfig){
        return urlConfig['target'] === '_blank' ? urlConfig['target'] : '';
    }

    private addSrefParams(urlConfig, stateName, params){
        urlConfig['sref'] = {};
        urlConfig['sref']['state'] = stateName;
        urlConfig['sref']['params'] = params;
        urlConfig['sref']['opts'] = {reload: true, inherit: false};
    }

    get advancedSearch() {
        return this.searchFieldsService.advancedSearch;
    }

    @preventStateReload
    private switchAdvancedSearch() {
        this.searchFieldsService.advancedSearch = !this.searchFieldsService.advancedSearch;
        if (!this.searchFieldsService.advancedSearch) {
            this.smoothScrollUtil.focusOn('searchBar');
        }
        this.$location.search('mode', this.searchFieldsService.advancedSearch ? 'advanced' : 'simple');
        this.$timeout(() => {
            if (this.advancedSearch == true) {
                return document.querySelector('#advanced-search').focus();
            }
        }, 100);

        this.$mdDialog.hide();

    }

    private isSearchPageState() {
        return this.$state.current.name === STATE_NAMES.SEARCH;
    }

    public isRefworksActionEnabled() {
        return this.actionListService.isActionEnabled('RefWorks');
    }

    @beacon({'p': 'general', 'op': 'goToRefworks'})
    public refworksWithBeacon() {
    }

    public isSummonOverAlma() {
        return this.configurationUtil.getSummonOverAlma();
    }
    
    @beacon({'p': 'general', 'op': 'gotoSearchHistory'})
    goToSearchHistory() {
        this.closeLinksMenu();
    }

    get searchHistoryParams() {
        return {vid: getVid(), lang: this.$translate.use(), section: 'search_history'};
    }

    public isReportProblem() {
       return  this.reportProblemService.isReportProblem();
    }

    public openReportFromMainMenu() {
        this.reportProblemService._openFromMainMenu = true;
        this.$mdDialog.hide();
        this.$timeout(()=> {
            document.body.style.overflowY = 'hidden';
        }, 0);
    }

    private getAnalyticsRequestType(url) {
        switch (url) {
            case "BlankIll" :
                return "Resource Sharing";
            case "PurchaseRequest":
                return "Purchase Request";
        }
    }

    get isMobileResearchAssistantByIcon(): boolean {
        return isShowReasearcherAssistantByIcon();
    }

    public initMobileResearcher(){
        this.$mdDialog.hide();
    }

    get researchAssistantMobileParams() {
        return {vid: this.vid, lang: this.$translate.use()};
    }

    public getDataQA(label) {
        let lastPart;
        if (label) {
            lastPart = label.split('.').pop();
        } else {
            lastPart = "";
        }
        return 'mainmenu.' + lastPart.toLowerCase().replace(/[^a-z]/g, '')
    }

    private hideRapidoBlankFormLinkBasedOnUserGroup(){
        let hideWhenNotLoggedIn = window.appConfig['system-configuration'].rapido_hide_blank_form_link_when_user_not_logged_in;
        let hideBlankFormForUserGroups = window.appConfig['system-configuration'].rapido_hide_blank_ill_from_link_menu;
        let userGroupsToHideFrom = window.appConfig['system-configuration'].rapido_hide_blank_form_link_user_groups;
        let currentUserGroup = this.jwtUtilService.getDecodedToken().userGroup ? this.jwtUtilService.getDecodedToken().userGroup.toUpperCase() : undefined;
        let isGuestUser = !this.userSessionManagerService.getUserName();
        if(isGuestUser){
            return hideWhenNotLoggedIn;
        }
        if(hideBlankFormForUserGroups){
            const groups: string[] = Object.keys(userGroupsToHideFrom).map(key => userGroupsToHideFrom[key].toUpperCase());
            return groups.indexOf(currentUserGroup) !== -1;
        }
        return false;
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/mainMenu/mainMenu.directive.ts